<template>
    <div>
        <b-modal id="modal-prevent-closing" centered class="header-modal" no-close-on-backdrop hide-footer ref="modal-choose-type-file">
            <div class="modal-choose-type-file__body container wrap-form-create-update-chapter">
                <!-- <h4>
                    <strong>
                        Xóa {{ getNameType }}
                    </strong>
                </h4>
                <p class="font-size-20 text-center primary-color-txt font-sanpro-light">
                    Bạn có muốn xóa {{ getNameType }} này không? <br />
                </p> -->
                <div class="modal__actions text-right">
                    <img class="icon-delete btn-close custom-cursor" src="@/assets/img/x.png" @click="handleHideModal"/>
                    <!-- <a href="javascript:;" class="primary-color-txt font-size-17 btn-cancel" @click="handleHideModal"></a> -->
                    <!-- <a href="javascript:;" class="btn btn-err font-size-17 font-sanpro-semibold btn-delete" @click="handleDelete()">Đồng ý</a> -->
                </div>

                <div class="modal__contents">
                    <h4><strong>Chọn định dạng PDF</strong></h4>
                   <div class="modal__contents_item">
                        <span @click="uploadExcercisePdf(typeMultipleChoice)">Đề trắc nghiệm</span>
                   </div>

                   <div class="modal__contents_item">
                        <span @click="uploadExcercisePdf(typeMixed)">Đề hỗn hợp (trắc nghiệm và tự luận)</span>
                   </div>

                   <div class="modal__contents_action">
                        <button  @click="handleHideModal">Hủy bỏ</button>
                   </div>

                </div>
                <input type="file"
                        hidden
                        name="file"
                        id="fileInputUpload"
                        class="hidden-input"
                        @change="onChangeUploadFile"
                        ref="file"
                        accept=".pdf"
                    />
            </div>
        </b-modal>
    </div>
</template>

<script>
import { getQuestionFilePDF } from './../../../_api/LessonClassSchoolServices'
export default {
    name: "ModalChooseTypePDF",
    data(){
        return {
            path:'',
            typeUpload:0,
            typeMultipleChoice:5,
            typeMixed:6,
        }
    },
    mounted(){
        this.handleShowModal()
    },
    methods: {
        uploadExcercisePdf(typeUpload){
            this.typeUpload = typeUpload
            this.$refs.file.click()
        },
        onChangeUploadFile(){
            let self = this
            this.file = this.$refs.file.files[0]
            const formData = new FormData();
            formData.append('file', this.file);
            this.$refs.file.value = '';
            getQuestionFilePDF(formData).then(res => {
                if (res && res.data && !res.errors) {
                    self.path = res.data
                    self.handleDone()
                 }
            })

        },
        handleDone() {
            this.handleHideModal()
            this.$emit('handleDone',{
                typeUpload:this.typeUpload,
                path:this.path
            })
        },
        handleHideModal() {
            this.$emit('closeModal')
        },
        handleShowModal() {
            this.$refs['modal-choose-type-file'].show()
        },
    }
}
</script>

<style>
/* .btn-cancel {
    color: black;
    background-color: red;
    border-radius: 50%;
    
} */

.btn-close {
    width: 10px;
}

.custom-cursor {
    cursor: pointer;
}

.modal__contents {
    text-align: center;
   display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
}

.modal__contents_item {
    /* border: 1px solid; */
    width: 60%;
    padding: 8px 0;
    border-radius: 10px;
    margin: 10px 0;
    color: rgb(48, 141, 216);
    background-color: gainsboro;
    cursor: pointer;
}

.modal__contents_action button {
    border: none;
    margin: 25px 0 10px 0;
    color: red;
    background: none;
}

.modal__contents h4 {
    margin-bottom: 20px;
}
</style>
<style lang="scss" scoped>
.modal-content {
    background-color: red;
}

.modal-choose-type-file__body {
    padding: 20px;
    background-color: white;
    border-radius: 15px;
    .modal__actions{
        
        .btn-delete{
            color: white;
            background: #fe0201;
            padding: 5px 20px 5px 20px;
            border-radius: 15px;
            font-family: sans-serif;
        }
        .btn-cancel{
            margin-right: 10px;
            font-family: sans-serif;
        }
    }
}

.form_action {
    margin-top: 10px;
    padding-bottom: 10px;
}

.justity-content-space-between {
    justify-content: center
}
</style>